module.exports = __webpack_public_path__ + "img/Monte_Kope_70.03aed9bc.jpg";